<button [ngClass]="class" (click)="HandleClick()">
    <ng-content select="[icon]"></ng-content>
    <ng-content select="[label]"></ng-content>
</button>
